<div class="flex items-center">
    <div [class]="'bg-gray-800 dark:bg-gray-100'">
        <!-- add first letters of organisation name as initials -->
        <div *ngIf="!organisation?.logoSmall" [class]="logoSize + ' ' + borderRadius">
            <div  [class]="'flex items-center justify-center text-white dark:text-gray-800 ' + logoSize + ' ' + borderRadius + ' ' + textSize">
                {{ organisation?.initials }}
            </div>
        </div>
        <div *ngIf="organisation?.logoSmall" [class]="logoSize + ' ' + borderRadius">
            <img [src]="organisation?.logoSmall" alt="Organisation Logo" class="w-full">
        </div>
    </div>

    <div *ngIf="withText" class="ml-4 flex flex-col overflow-hidden">
        <div 
            [class]="'w-full overflow-hidden text-ellipsis whitespace-nowrap leading-normal text-current opacity-80 ' + textSize"
        >
            {{ organisation.name }}
        </div>
        @if (showState) {
            <div 
                class="mt-0.5 w-full overflow-hidden text-ellipsis whitespace-nowrap text-sm leading-normal text-current opacity-50"
            >
                {{ organisation?.address?.state }}
            </div>
        }
    </div> 
</div>